import restService from "../rest-service/RestService";
import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import {
    IPageConfigurationAvailableColumns3,
    IPageConfigurationDataModel3,
    IPageConfigurationDefaultModel,
    IPageConfigurationDefaultOptionsModel,
    IPageConfigurationModel3,
    IPageConfigurationModel4,
    IPageConfigurationTypeQueryParams,
    PageConfigurationDataModel3,
    PageConfigurationModel4,
    PageConfigurationTypeEnum
} from "./Models";
import { OptionalColumnEnum } from "../../common/enums/DRCXEnums";

const PageConfigurationService = {
    // #region Version 1 API

    setPageConfigurationDefault: async function (groupId: number, model: IPageConfigurationDefaultModel, signal?: AbortSignal): Promise<IPageConfigurationDefaultModel> {
        var path: string = [
            "groups",
            groupId,
            "pageconfigurationdefault"
        ].join("/");

        const response = await restService.put<IPageConfigurationDefaultModel, IPageConfigurationDefaultModel>(path, model, signal);
        return response.data;
    },

    getPageConfigurationDefaultOptions: async function (groupId: number, configurationID: number, signal?: AbortSignal): Promise<IPageConfigurationDefaultOptionsModel> {
        var path: string = [
            "groups",
            groupId,
            "pageconfigurations",
            configurationID,
            "defaultoptions"
        ].join("/");

        const response = await restService.get<IPageConfigurationDefaultOptionsModel>(path, signal);
        return response.data;
    },

    // #endregion Version 1 API

    // #region Version 3 API

    getAccessiblePageConfigurations3: async function (groupId: number, pcType?: PageConfigurationTypeEnum, signal?: AbortSignal): Promise<PageConfigurationDataModel3> {
        const path: string = [
            "groups",
            groupId,
            "pageconfigurations"
        ].join("/");

        var queryParams: IPageConfigurationTypeQueryParams = {
            pcType: pcType ? pcType : PageConfigurationTypeEnum.SummaryListing_RTS
        };

        const response = await restService.get<IPageConfigurationDataModel3, IPageConfigurationTypeQueryParams>(path, signal, queryParams);
        return new PageConfigurationDataModel3(response.data);
    },
    getAllPageConfigurations: async function (groupId: number, pcType?: PageConfigurationTypeEnum, signal?: AbortSignal): Promise<PageConfigurationDataModel3> {

        const path: string = `/groups/${groupId}/pageconfigurations/all`;

        var queryParams: IPageConfigurationTypeQueryParams = {
            pcType: pcType ? pcType : PageConfigurationTypeEnum.SummaryListing_RTS
        };

        const response = await restService.get<IPageConfigurationDataModel3, IPageConfigurationTypeQueryParams>(path, signal, queryParams);
        return new PageConfigurationDataModel3(response.data);
    },
    getAccessiblePageConfiguration4: async function (groupId: number, 
        configurationId: number, 
        signal?: AbortSignal): Promise<PageConfigurationModel4> {

        var path: string = [
            "v4",
            "groups",
            groupId,
            "pageconfigurations",
            configurationId
        ].join("/");

        const response = await restService.get<IPageConfigurationModel4>(path, signal);
        return new PageConfigurationModel4(response.data);
    },

    // TODO: These return types aren't correct!
    // Returns ID of new configuration
    addPageConfiguration3: async function (groupId: number, model: IPageConfigurationModel3, signal?: AbortSignal): Promise<IPageConfigurationModel3> {
        var path: string = [
            "v3",
            "groups",
            groupId,
            "pageconfiguration"
        ].join("/");

        const response = await restService.post<IPageConfigurationModel3, IPageConfigurationModel3>(path, model, signal);
        return response.data;
    },

    savePageConfiguration: async function (groupId: number, model: PageConfigurationModel4, signal?: AbortSignal): Promise<PageConfigurationModel4> {
        
        // make sure attribute schema key is set correctly
        const configuration = {...model} as PageConfigurationModel4;
        configuration.sections.forEach(o => {
            o.columns.filter(o => o.optionalColumn === OptionalColumnEnum.DeviceAttributeSchema ||
                                o.optionalColumn === OptionalColumnEnum.WellAttributeSchema ||
                                o.optionalColumn === OptionalColumnEnum.TankAttributeSchema ||
                                o.optionalColumn === OptionalColumnEnum.TagAttributeSchema).forEach(v => {
                                    if (v.id !== undefined) {
                                        v.key = v.id.toString();
                                    }
                                });
        });

        var path: string = [
            "v4",
            "groups",
            groupId,
            "pageconfiguration"
        ].join("/");

        if (model.id === -1) {
            const response = await restService.post<PageConfigurationModel4, PageConfigurationModel4>(path, configuration, signal);
            return response.data;

        } else {
            const response = await restService.put<PageConfigurationModel4, PageConfigurationModel4>(path, configuration, signal);
            return response.data;
        }

    },

    deletePageConfiguration: async function (groupId: number, model: IPageConfigurationModel4, signal?: AbortSignal): Promise<IPageConfigurationModel4> {
        var path: string = [
            "v4",
            "groups",
            groupId,
            "pageconfiguration"
        ].join("/");

        const response = await restService.delete<IPageConfigurationModel4, undefined>(path, signal, undefined, model);
        return response.data;
    },

    getAvailablePageConfigurationItems3: async function (groupId: number, pcType?: PageConfigurationTypeEnum, deviceType?: DeviceTypesEnum, signal?: AbortSignal): Promise<IPageConfigurationAvailableColumns3> {
        var path: string = [
            "v3",
            "groups",
            groupId,
            "pageconfigurationitems"
        ].join("/");

        var queryParams: IPageConfigurationTypeQueryParams = {
            pcType: pcType ? pcType : PageConfigurationTypeEnum.SummaryListing_RTS,
            deviceType: deviceType
        };

        const response = await restService.get<IPageConfigurationAvailableColumns3, IPageConfigurationTypeQueryParams>(path, signal, queryParams);

        return response.data;
    },

    // #endregion Version 3 API

    hidePageConfigurations: async function (groupID: number, idList: number [], hide: boolean): Promise<void> {
        const path = `groups/${groupID}/pageconfiguration/${hide ? 'hide' : 'unhide'}`;
        await restService.post<number[], void>(path, idList);
    },
    deletePageConfigurations: async function (groupID: number, idList: number []): Promise<void> {
        const path = `groups/${groupID}/pageconfigurations`;
        await restService.delete<number[], void>(path, undefined, undefined, idList);
    },

};

export default PageConfigurationService;
